import setting from "./setting"
import paper from "./paper"
import performance from "./performance"
import projectManagement from "./project-management"
import participant from './participant'
import classical from "./classical"
import evaluation from "./evaluation"
import report from "./report"

const main = Object.assign({
    dashboard: {
        icon: 'dashboard',
        text: 'Dashboard',
        route: 'admin.dashboard',
    },
    inbox: {
        icon: 'inbox',
        text: 'Inbox',
        route: 'admin.classical.chat',
        role: {
            classical: [ 'attendant', 'admin', 'project-manager', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
        }
    },
}, classical, paper, projectManagement, performance, evaluation, setting, report)

export default main
